import Task from './Task';
import { createError } from '../error';

const partialClaimURL = '/partial_claim';

class PartialClaimSaveTask extends Task {
  constructor(
    $q,
    APIService,
    DataSyncService,
    PartialClaimService,
    ClaimService,
    DocumentService,
    LogService
  ) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.DataSyncService = DataSyncService;
    this.PartialClaimService = PartialClaimService;
    this.ClaimService = ClaimService;
    this.DocumentService = DocumentService;
    this.LogService = LogService;

    this._serializedPrimaryClaim = null;
    this._serializedSecondaryClaims = [];
    this._primaryClaim = null;
    this._secondaryClaims = [];
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set partialClaim(partialClaim) {
    this._partialClaim = partialClaim;
    this.serializedPartialClaim = this.PartialClaimService.serialize(partialClaim);
  }

  get partialClaim() {
    return this._partialClaim;
  }

  set serializedPartialClaim(data) {
    this._serializedPartialClaim = data;
  }

  get serializedPartialClaim() {
    return this._serializedPartialClaim;
  }

  /**
   * Public methods
   */

  populate(data) {
    this.serializedPartialClaim = data;
    this.LogService && this.LogService.debug(`PartialClaimSaveTask populated with data:`, data, `this:`, this);
  }

  serialize() {
    return this.serializedPartialClaim;
  }

  execute() {
    const postData = {
      staffing_users_id: this.serializedPartialClaim && this.serializedPartialClaim.staffing_users_id,
      events_id: this.serializedPartialClaim && this.serializedPartialClaim.events_id,
      data: this.serializedPartialClaim && this.serializedPartialClaim.data,
    };
    return this.APIService.post(partialClaimURL, postData);
  }

  /**
   * Private methods
   */


}

export default PartialClaimSaveTask;
